export	const API_URL =  "http://ydzbj.ydtg.com.cn" ;

export const LOGIN =  'login';
export const LOGOUT = 'logout';
export const TITLE =  'title';
export const USER =  'user';
export const FOOTERSHOW =  'footerShow';
export const TABNAME =  'tabname';



// WEBPACK FOOTER //
// ./src/store/types.js